import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTg = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 12,
	viewBox: "0 0 14 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Telegram",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Combined-Shape",
			d: "M6.00487 7.44185L5.8007 10.5007C6.1007 10.5007 6.23325 10.3635 6.4007 10.2007L7.84206 8.79919L10.8407 11.0146C11.3926 11.3191 11.7908 11.1615 11.9283 10.5023L13.8968 1.22597C14.0983 0.417955 13.5888 0.0514747 13.0609 0.291155L1.50186 4.74825C0.712851 5.06472 0.717451 5.50491 1.35804 5.70105L4.32434 6.62688L11.1916 2.29438C11.5158 2.09779 11.8134 2.20349 11.5692 2.42022L6.0047 7.44172L6.00487 7.44185Z",
			fill: ""
		})
	})
});
export default SvgTg;
